module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('md-layout', {
    staticClass: "bg-register register-doctor register--wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo col-sm-6",
    staticStyle: {
      "padding-top": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "mt-panel register-panel"
  }, [_c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('h3', {
    staticClass: "md-title color--title section--title"
  }, [_vm._v("\n                    " + _vm._s(_vm.translate.pages.register.subtitle) + "\n                    "), _c('span', {
    staticClass: "badge badge-title"
  }, [_vm._v(_vm._s(_vm.translate.pages.register.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "row container language--box language--register"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": "",
      "md-align": "end"
    }
  }, [_c('span', {
    staticClass: "language"
  }, [_c('md-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('md-select', {
    on: {
      "change": _vm.updateLang
    },
    model: {
      value: (_vm.lang),
      callback: function($$v) {
        _vm.lang = $$v
      },
      expression: "lang"
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('md-option', {
      key: language.id,
      attrs: {
        "value": language.code
      }
    }, [_vm._v(_vm._s(language.name))])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "register-steps"
  }, [_c('div', {
    class: ['col-xs-6', 'mt-tab', {
      'mt-tab-active': _vm.data.activeTab === 0
    }]
  }, [_c('span', {
    staticClass: "badge circle"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.translate.pages.register.tabs.personal_information))])]), _vm._v(" "), _c('div', {
    class: ['col-xs-6', 'mt-tab', {
      'mt-tab-active': _vm.data.activeTab === 1
    }]
  }, [_c('span', {
    staticClass: "badge circle"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.translate.pages.register.tabs.confirmation))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.activeTab === 0),
      expression: "data.activeTab === 0"
    }],
    staticClass: "col-sm-12 register-first-step"
  }, [(_vm.update_massive) ? _c('div', [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "color": "#76be33"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "background": "rgb(33, 150, 243)",
      "padding": "10px",
      "border-radius": "3px"
    }
  }, [_vm._v("Por favor, complete sus datos")])])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": "",
      "data-vv-scope": "form-doctor"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit('form-doctor')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "md-theme": "green"
    },
    model: {
      value: (_vm.doctor.is_institution),
      callback: function($$v) {
        _vm.doctor.is_institution = $$v
      },
      expression: "doctor.is_institution"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.fields.is_institution))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('email')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.code))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    on: {
      "change": _vm.changeCode
    },
    model: {
      value: (_vm.doctor.code),
      callback: function($$v) {
        _vm.doctor.code = $$v
      },
      expression: "doctor.code"
    }
  }), _vm._v(" "), (_vm.errors.code) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.code))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: 1234567-8")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.name')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.name))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-name": "name",
      "data-vv-rules": "required|min:1",
      "required": ""
    },
    model: {
      value: (_vm.doctor.name),
      callback: function($$v) {
        _vm.doctor.name = $$v
      },
      expression: "doctor.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: SERVICIO MEDICO DENTAL")]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.name')))])], 1)], 1), _vm._v(" "), (!_vm.doctor.is_institution) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.lastname')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.lastname))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-name": "lastname",
      "data-vv-rules": "alpha_spaces|min:1"
    },
    model: {
      value: (_vm.doctor.lastname),
      callback: function($$v) {
        _vm.doctor.lastname = $$v
      },
      expression: "doctor.lastname"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.lastname')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.doctor.is_institution) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.lastname2')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.lastname2))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-name": "lastname2",
      "data-vv-rules": "alpha_spaces|min:1"
    },
    model: {
      value: (_vm.doctor.lastname2),
      callback: function($$v) {
        _vm.doctor.lastname2 = $$v
      },
      expression: "doctor.lastname2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.lastname2')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('email')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.email) + " ")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.changeEmail()
      }
    },
    model: {
      value: (_vm.doctor.email),
      callback: function($$v) {
        _vm.doctor.email = $$v
      },
      expression: "doctor.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: correo@correo.cl")]), _vm._v(" "), (_vm.errors.email) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.phone')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.phone))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-name": "phone",
      "data-vv-rules": "required|numeric|min:6|max:12",
      "required": ""
    },
    model: {
      value: (_vm.doctor.phone),
      callback: function($$v) {
        _vm.doctor.phone = $$v
      },
      expression: "doctor.phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua",
    attrs: {
      "data-v-44c3599e": ""
    }
  }, [_vm._v("ej: 9999999")]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.phone')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.password')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.password))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    ref: "password",
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "data-vv-name": "password",
      "data-vv-rules": "required|min:6",
      "required": ""
    },
    model: {
      value: (_vm.doctor.password),
      callback: function($$v) {
        _vm.doctor.password = $$v
      },
      expression: "doctor.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.password')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.password_confirmation')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.register.fields.password_confirmation))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "password",
      "data-vv-name": "password_confirmation",
      "data-vv-as": "Confirmar Contraseña",
      "data-vv-rules": "required|min:6|confirmed:password",
      "required": ""
    },
    model: {
      value: (_vm.doctor.password_confirmation),
      callback: function($$v) {
        _vm.doctor.password_confirmation = $$v
      },
      expression: "doctor.password_confirmation"
    }
  }), _vm._v(" "), (_vm.doctor.password != _vm.doctor.password_confirmation) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.password_confirmation')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mar-top-2 mt-table-bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "subtitle"
  }, [_vm._v("Seleccionar Tipo")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_1",
      "md-theme": "green",
      "name": "medicina_checkbox_1"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_1),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_1 = $$v
      },
      expression: "doctor.medicina_checkbox_1"
    }
  }, [_vm._v("Medicina")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_2",
      "md-theme": "green",
      "name": "medicina_checkbox_2"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_2),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_2 = $$v
      },
      expression: "doctor.medicina_checkbox_2"
    }
  }, [_vm._v("Profesionales Auxiliares de la Medicina")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_3",
      "md-theme": "green",
      "name": "medicina_checkbox_3"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_3),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_3 = $$v
      },
      expression: "doctor.medicina_checkbox_3"
    }
  }, [_vm._v("Especialidades Odontológicas")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_4",
      "md-theme": "green",
      "name": "medicina_checkbox_4"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_4),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_4 = $$v
      },
      expression: "doctor.medicina_checkbox_4"
    }
  }, [_vm._v("Imagenología")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_5",
      "md-theme": "green",
      "name": "medicina_checkbox_5"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_5),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_5 = $$v
      },
      expression: "doctor.medicina_checkbox_5"
    }
  }, [_vm._v("Medicina Tradicional y Complementaria")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "medicina_checkbox_6",
      "md-theme": "green",
      "name": "medicina_checkbox_6"
    },
    model: {
      value: (_vm.doctor.medicina_checkbox_6),
      callback: function($$v) {
        _vm.doctor.medicina_checkbox_6 = $$v
      },
      expression: "doctor.medicina_checkbox_6"
    }
  }, [_vm._v("Tratamientos")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mar-top-2"
  }, [_c('md-input-container', {
    staticStyle: {
      "margin": "0 !important"
    }
  }, [_c('md-input', {
    attrs: {
      "type": "text",
      "placeholder": "Buscar Especialidad..."
    },
    model: {
      value: (_vm.filterSpecialities),
      callback: function($$v) {
        _vm.filterSpecialities = $$v
      },
      expression: "filterSpecialities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "multiple checkbox-list"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translate.pages.register.fields.specialities))]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, _vm._l((_vm.filteredSpecialities), function(speciality) {
    return _c('md-checkbox', {
      key: speciality.id,
      staticClass: "option",
      on: {
        "change": function($event) {
          _vm.onChosen($event, speciality.id)
        }
      },
      model: {
        value: (speciality.checked),
        callback: function($$v) {
          speciality.checked = $$v
        },
        expression: "speciality.checked"
      }
    }, [_vm._v(_vm._s(speciality.name))])
  }))]), _vm._v(" "), _c('label', {
    staticClass: "subtitle",
    class: {
      error: _vm.errors.specialities
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.translate.pages.register.fields.selects_specialties) + "\n                                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 mar-top-2 checkbox-list"
  }, [_c('div', [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "notification_appointment",
      "md-theme": "green",
      "name": "notification_appointment"
    },
    model: {
      value: (_vm.doctor.notification_appointment),
      callback: function($$v) {
        _vm.doctor.notification_appointment = $$v
      },
      expression: "doctor.notification_appointment"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.fields.appointments))])], 1), _vm._v(" "), _c('div', [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "notification_mail",
      "md-theme": "green",
      "name": "notification_mail"
    },
    model: {
      value: (_vm.doctor.notification_mail),
      callback: function($$v) {
        _vm.doctor.notification_mail = $$v
      },
      expression: "doctor.notification_mail"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.fields.notification))])], 1), _vm._v(" "), _c('div', [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "need_box",
      "md-theme": "green",
      "name": "need_box"
    },
    model: {
      value: (_vm.doctor.need_box),
      callback: function($$v) {
        _vm.doctor.need_box = $$v
      },
      expression: "doctor.need_box"
    }
  }, [_vm._v("Necesito un BOX")])], 1)]), _vm._v(" "), (_vm.doctor.need_box) ? _c('div', {
    staticClass: "bonus_container medibox",
    staticStyle: {
      "width": "100%",
      "float": "left",
      "background": "rgba(234, 234, 234, 0.46)"
    }
  }, [_c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#00bcd4",
      "color": "white",
      "padding": "10px",
      "border-radius": "10px"
    }
  }, [_vm._v("MediBox")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', {
    staticStyle: {
      "display": "block",
      "border-bottom": "1px solid #c1c0c0",
      "width": "100%",
      "margin-bottom": "25px"
    }
  }, [_vm._v(" Indique donde prefiere el Box")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Provincia")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.data.region.label == ''
    },
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.regions,
      "placeholder": "Provincia",
      "required": "",
      "data-vv-name": "region",
      "on-change": _vm.changeRegion
    },
    model: {
      value: (_vm.data.region.label),
      callback: function($$v) {
        _vm.data.region.label = $$v
      },
      expression: "data.region.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Provincia es requerido")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Comuna")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.data.city.label == ''
    },
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.comunities,
      "placeholder": "Comuna",
      "required": "",
      "data-vv-name": "city",
      "on-change": _vm.changeCity,
      "disabled": _vm.data.region.value == '0'
    },
    model: {
      value: (_vm.data.city.label),
      callback: function($$v) {
        _vm.data.city.label = $$v
      },
      expression: "data.city.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Comuna es requerido")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', {
    staticStyle: {
      "display": "block",
      "border-bottom": "1px solid #c1c0c0",
      "width": "100%",
      "margin-bottom": "25px"
    }
  }, [_vm._v("\n                                                Indique el periodo de arriendo que desea\n                                            ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.data.box_plan.label == ''
    },
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.box_plans,
      "required": "",
      "data-vv-name": "box_plan",
      "placeholder": "Periodo de Arriendo"
    },
    model: {
      value: (_vm.data.box_plan.label),
      callback: function($$v) {
        _vm.data.box_plan.label = $$v
      },
      expression: "data.box_plan.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Periodo de arriendo es requerido")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', {
    staticStyle: {
      "display": "block",
      "border-bottom": "1px solid #c1c0c0",
      "width": "100%",
      "margin-bottom": "25px"
    }
  }, [_vm._v("\n                                                Indique Especialidad, Horarios y Precio\n                                            ")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Especialidad")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.data.specialty.label == ''
    },
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.filteredSpecialities,
      "placeholder": "Especialidad",
      "required": "",
      "data-vv-name": "box_spe",
      "on-change": _vm.changeSpecialty
    },
    model: {
      value: (_vm.data.specialty.label),
      callback: function($$v) {
        _vm.data.specialty.label = $$v
      },
      expression: "data.specialty.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Especialidad es requerido")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Precio")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.data.specialty.label == ''
    },
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm._errors.has('form-doctor.price')
    }
  }, [_c('label', [_vm._v(" Precio ")]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-name": "price",
      "data-vv-rules": "required|numeric",
      "required": ""
    },
    model: {
      value: (_vm.data.price),
      callback: function($$v) {
        _vm.data.price = $$v
      },
      expression: "data.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua",
    attrs: {
      "data-v-44c3599e": ""
    }
  }, [_vm._v("ej: 9999999")]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm._errors.first('form-doctor.price')))])], 1)], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("   Horario Mañana")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('ul', {
    staticClass: "schedule_days"
  }, [_c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio1),
      callback: function($$v) {
        _vm.radio1 = $$v
      },
      expression: "radio1"
    }
  }, [_vm._v("Lunes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio2),
      callback: function($$v) {
        _vm.radio2 = $$v
      },
      expression: "radio2"
    }
  }, [_vm._v("Martes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio3),
      callback: function($$v) {
        _vm.radio3 = $$v
      },
      expression: "radio3"
    }
  }, [_vm._v("Miercoles")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio4),
      callback: function($$v) {
        _vm.radio4 = $$v
      },
      expression: "radio4"
    }
  }, [_vm._v("Jueves")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio5),
      callback: function($$v) {
        _vm.radio5 = $$v
      },
      expression: "radio5"
    }
  }, [_vm._v("Viernes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio6),
      callback: function($$v) {
        _vm.radio6 = $$v
      },
      expression: "radio6"
    }
  }, [_vm._v("Sabado")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.radio7),
      callback: function($$v) {
        _vm.radio7 = $$v
      },
      expression: "radio7"
    }
  }, [_vm._v("Domingo")])], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised pull-right md-size",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetSchedule(1)
      }
    }
  }, [_vm._v("\n                                                Reiniciar\n                                            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("   Horario Tarde")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    staticStyle: {
      "margin-top": "5px !important",
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('ul', {
    staticClass: "schedule_days"
  }, [_c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio8),
      callback: function($$v) {
        _vm.radio8 = $$v
      },
      expression: "radio8"
    }
  }, [_vm._v("Lunes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio9),
      callback: function($$v) {
        _vm.radio9 = $$v
      },
      expression: "radio9"
    }
  }, [_vm._v("Martes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio10),
      callback: function($$v) {
        _vm.radio10 = $$v
      },
      expression: "radio10"
    }
  }, [_vm._v("Miercoles")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio11),
      callback: function($$v) {
        _vm.radio11 = $$v
      },
      expression: "radio11"
    }
  }, [_vm._v("Jueves")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio12),
      callback: function($$v) {
        _vm.radio12 = $$v
      },
      expression: "radio12"
    }
  }, [_vm._v("Viernes")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio13),
      callback: function($$v) {
        _vm.radio13 = $$v
      },
      expression: "radio13"
    }
  }, [_vm._v("Sabado")])], 1), _vm._v(" "), _c('li', [_c('md-checkbox', {
    attrs: {
      "id": "my-test1",
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.radio14),
      callback: function($$v) {
        _vm.radio14 = $$v
      },
      expression: "radio14"
    }
  }, [_vm._v("Domingo")])], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised pull-right md-size",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetSchedule(2)
      }
    }
  }, [_vm._v("\n                                                Reiniciar\n                                            ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.doctor.prefix == 'CL') ? _c('div', {
    staticClass: "bonus_container",
    staticStyle: {
      "background": "#eaeaea75",
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#f34b4b",
      "color": "white",
      "padding": "10px",
      "border-radius": "10px"
    }
  }, [_vm._v("\n                                    Bonificación a Pacientes COLABORAMED\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "10px"
    }
  }, [_vm._v("\n                                    Ingrese el Descuento que ofrece para cada tipo de Paciente\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_particular"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.bon_particular),
      callback: function($$v) {
        _vm.doctor.bon_particular = $$v
      },
      expression: "doctor.bon_particular"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_fonasa"
    }
  }, [_vm._v("FONASA")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento de Copago")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.bon_fonasa),
      callback: function($$v) {
        _vm.doctor.bon_fonasa = $$v
      },
      expression: "doctor.bon_fonasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_isapre"
    }
  }, [_vm._v("ISAPRE")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento de Copago")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.bon_isapre),
      callback: function($$v) {
        _vm.doctor.bon_isapre = $$v
      },
      expression: "doctor.bon_isapre"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "10px",
      "padding": "15px !important"
    }
  }, [_c('b', [_vm._v("Condiciones específicas:")]), _vm._v("\n                                    Me comprometo a cumplir estos descuentos a todos los Pacientes de COLABORAMED por el plazo mínimo de un año,\n                                    y mientras esté vigente mi Registro en COLABORAMED.\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mar-top-1"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "md-body-2 form-note"
  }, [_c('strong', [_vm._v("Importante:")]), _vm._v(" Todos los campos en "), _c('span', {
    staticClass: "color--red"
  }, [_vm._v("*")]), _vm._v(" son requeridos.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary pull-right md-size",
    attrs: {
      "type": "submit",
      "disabled": _vm.process
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.translate.actions.next) + " "), _c('md-icon', {
    staticStyle: {
      "margin-bottom": "3px"
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.activeTab === 1),
      expression: "data.activeTab === 1"
    }],
    staticClass: "col-sm-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.confirmation.isSuccess),
      expression: "data.confirmation.isSuccess"
    }],
    staticClass: "col-sm-12 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    staticStyle: {
      "width": "100px!important"
    },
    attrs: {
      "src": require("../../assets/img/icon-success.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-display-2",
    staticStyle: {
      "color": "#76be33"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.message.success.title) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "md-body-2",
    staticStyle: {
      "color": "#8a9299 !important"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.message.success.description) + " "), _c('strong', [_vm._v(_vm._s(_vm.doctor.paid_code))]), _vm._v(".")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-size btn--green",
    staticStyle: {
      "background-color": "#76be33",
      "color": "#ffffff",
      "margin-bottom": "2em",
      "line-height": "46px"
    },
    attrs: {
      "href": "https://tienda.agendaenlinea.cl/",
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("shopping_cart")]), _vm._v(" Pagar en Linea\n                        ")], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-size btn--gray",
    staticStyle: {
      "background-color": "#f0f0f0 !important",
      "color": "#4d5667 !important",
      "margin-bottom": "2em",
      "line-height": "46px"
    },
    attrs: {
      "href": "office",
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("phonelink")]), _vm._v(" Oficina Virtual\n                        ")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.confirmation.isError),
      expression: "data.confirmation.isError"
    }],
    staticClass: "col-sm-12 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    staticStyle: {
      "width": "100px!important"
    },
    attrs: {
      "src": require("../../assets/img/icon-error.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-display-2",
    staticStyle: {
      "color": "#f26061"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.message.error.title))]), _vm._v(" "), _c('p', {
    staticClass: "md-body-2",
    staticStyle: {
      "color": "#8a9299 !important"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.register.message.error.description))])])])])], 1), _vm._v(" "), _c('br')])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33660f70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/RegisterDoctor.vue
// module id = 587
// module chunks = 1